export const ConstantsInfra = {
  GRID: {
    PAGINATOR: {
      ITEMS_PER_PAGE_LABEL: "Itens por página",
      LAST_PAGE_LABEL: "Última Página",
      PREVIOUS_PAGE_LABEL: "Anterior",
      NEXT_PAGE_LABEL:"Próximo"
    }
  }
};
